import "./App.css";
import { Navbar } from "./components/landing/Navbar";
import { HeroSection } from "./components/landing/HeroSection";
import { ProblemAgitation } from "./components/landing/ProblemAgitation";
import { RoiCalculator } from "./components/landing/RoiCalculator";
import { HowItWorks } from "./components/landing/HowItWorks";
import { CaseStudy } from "./components/landing/CaseStudy";
import { Qualification } from "./components/landing/Qualification";
import { CtaSection } from "./components/landing/CtaSection";
import { Footer } from "./components/landing/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <HeroSection />
        <ProblemAgitation />
        <CaseStudy />
        <HowItWorks />
        <RoiCalculator />
        <Qualification />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
